import { Component, Input, Inject } from '@angular/core';

import { CountedIdentifierKind } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-generate-identifier',
    templateUrl: './side-effect-generate-identifier.component.html',
    standalone: false
})
export class SideEffectGenerateIdentifierComponent {
    identifierTypes: string[] = Object.keys(CountedIdentifierKind).filter((k) =>  CountedIdentifierKind.hasOwnProperty(k)).sort((a, b) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    });
    public _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.identifierType = this._seConfiguration.identifierType || null;
        this._seConfiguration.contextTarget = this._seConfiguration.contextTarget || "$.data.applicationNumber.value";
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }
}
